// Shared paper + digit-box sizing for the invite and phone-verification
// dialogs. Both used to be a fixed 520px card, which overflowed a phone
// screen (and the six code boxes overflowed inside it). These keep the
// desktop look and shrink to the viewport on small screens.
export const responsiveModalPaperSx = {
  position: 'relative',
  width: { xs: '100%', sm: 520 },
  maxWidth: { xs: 'calc(100vw - 16px)', sm: 520 },
  maxHeight: { xs: 'calc(100dvh - 16px)', sm: '90vh' },
  overflowY: 'auto',
  WebkitOverflowScrolling: 'touch',
  bgcolor: '#fff',
  borderRadius: { xs: '12px', sm: '16px' },
  boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
  outline: 'none',
  mx: 1,
};

// Login, forgot-password, and the /reset-password page share this card
// so the three auth surfaces line up: same width, radius, and shadow.
export const AUTH_CARD_MAX_WIDTH = 440;

export const authDialogPaperSx = {
  width: { xs: '90%', sm: AUTH_CARD_MAX_WIDTH },
  maxWidth: AUTH_CARD_MAX_WIDTH,
  bgcolor: '#fff',
  borderRadius: '16px',
  boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
  outline: 'none',
  overflow: 'hidden',
};

export const authFormSx = {
  width: '100%',
  minWidth: 0,
  maxWidth: '100%',
  m: 0,
  p: 0,
  boxShadow: 'none',
  borderRadius: 0,
  background: 'none',
  alignSelf: 'stretch',
};

export const authBackButtonSx = {
  width: 36,
  minWidth: 36,
  maxWidth: 36,
  height: 36,
  p: 0,
  color: '#374151',
  bgcolor: '#fff',
  background: '#fff',
  border: '1px solid #E5E7EB',
  borderRadius: '10px',
  boxShadow: 'none',
  '&:hover': { bgcolor: '#F9FAFB', background: '#F9FAFB', boxShadow: 'none' },
};

export const authFieldSx = {
  '& .MuiOutlinedInput-root': {
    height: 42,
    borderRadius: '12px',
    fontSize: '14px',
    '& fieldset': { borderColor: '#E5E7EB' },
    '&:hover fieldset': { borderColor: '#D1D5DB' },
    '&.Mui-focused fieldset': { borderColor: '#242258', borderWidth: 1 },
  },
};

export const authPrimaryButtonSx = {
  height: 46,
  bgcolor: '#242258',
  color: '#fff',
  fontSize: '14px',
  fontWeight: 600,
  borderRadius: '12px',
  textTransform: 'none',
  boxShadow: 'none',
  '&:hover': { bgcolor: '#1a1a45', boxShadow: 'none' },
  '&:disabled': { bgcolor: '#E5E7EB', color: '#9CA3AF' },
};

export const authForgotLinkSx = {
  display: 'inline',
  width: 'auto',
  minWidth: 0,
  m: 0,
  p: 0,
  background: 'none',
  bgcolor: 'transparent',
  border: 'none',
  boxShadow: 'none',
  color: '#242258',
  fontSize: '13px',
  fontWeight: 600,
  fontFamily: 'inherit',
  lineHeight: 1.4,
  textDecoration: 'underline',
  textTransform: 'none',
  cursor: 'pointer',
  '&:hover': { background: 'none', bgcolor: 'transparent', filter: 'none', boxShadow: 'none' },
};

export const codeDigitFieldSx = {
  flex: '1 1 0',
  minWidth: 36,
  maxWidth: 48,
  '& .MuiOutlinedInput-root': {
    height: { xs: 48, sm: 56 },
    borderRadius: '12px',
  },
};
